import moment from "moment-timezone";

const key = "migrate-header-model";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/4\/reports\?/);
};

const expectedHeaderProperties = [
	"Id",
	"EntityId",
	"FormId",
	"Number",
	"IsDeleted",
	"Date",
	"LastModified",
	"Submitted",
	"TimeZone",
	"History",
	"Periods"
];

const tripTypes = [
	{ Id: 948, Code: "1", Name: "1 :: 1/2 DAY, AM" },
	{ Id: 1882, Code: "10", Name: "10 :: SIX DAYS" },
	{ Id: 2333, Code: "11", Name: "11 :: SEVEN DAYS" },
	{ Id: 1603, Code: "12", Name: "12 :: EIGHT DAYS" },
	{ Id: 875, Code: "13", Name: "13 :: NINE DAYS" },
	{ Id: 1872, Code: "14", Name: "14 :: TEN DAYS" },
	{ Id: 1811, Code: "15", Name: "15 :: ELEVEN DAYS" },
	{ Id: 1896, Code: "16", Name: "16 :: TWELVE DAYS" },
	{ Id: 2260, Code: "17", Name: "17 :: 1/2 DAY AM (2nd trip)" },
	{ Id: 2103, Code: "18", Name: "18 :: 1/2 DAY PM (2nd trip)" },
	{ Id: 413, Code: "2", Name: "2 :: FULL DAY" },
	{ Id: 1981, Code: "21", Name: "21 :: 1/2 DAY, PM" },
	{ Id: 1590, Code: "23", Name: "23 :: 3/4 DAY (2nd trip)" },
	{ Id: 2751, Code: "25", Name: "25 :: 1½ DAYS" },
	{ Id: 176, Code: "29", Name: "29 :: 1/2 DAY, NIGHT (2nd trip)" },
	{ Id: 91, Code: "3", Name: "3 :: 3/4 DAY" },
	{ Id: 402, Code: "33", Name: "33 :: 3/4 DAY, NIGHT" },
	{ Id: 1360, Code: "4", Name: "4 :: OVERNIGHT" },
	{ Id: 2107, Code: "5", Name: "5 :: TWO DAYS" },
	{ Id: 350, Code: "6", Name: "6 :: THREE DAYS" },
	{ Id: 1724, Code: "7", Name: "7 :: FOUR DAYS" },
	{ Id: 1449, Code: "8", Name: "8 :: FIVE DAYS" },
	{ Id: 329, Code: "9", Name: "9 :: 1/2 DAY, NIGHT" }
];

const fieldNameToIdMap = {
	"Trip Type": { 
		Id: 59,
		Options: tripTypes,
		Type: "DataId"
	},
	"Departed": { 
		Id: 60,
		Type: "Date"
	},
	"# of Anglers": { 
		Id: 63,
		Type: "Number",
		DataId: 1858
	}
};

const modify = (resp) => {
	const reportHeaders = resp.data.Data;
	if(reportHeaders.length === 0) {
		return;
	}

	reportHeaders.forEach(header => {
		const propertyKeys = Object.keys(header);
	
		const unexpectedProperties = propertyKeys
			.filter((key) => !expectedHeaderProperties.includes(key))
			.map(key => {
				const newFieldValue = {
					FieldId: fieldNameToIdMap[key].Id
				};

				if(fieldNameToIdMap[key].Type === "DataId") {
					const data = tripTypes.find(tripType => tripType.Name === header[key]);
					newFieldValue.DataId = data.Id;
				}
				else if(fieldNameToIdMap[key].Type === "Date") {
					newFieldValue.Date = moment(header[key], "YYYY-MM-DD HH:mm:ss.SSSSSSS Z")
						.tz("America/New_York")
						.format();
				}
				else if(fieldNameToIdMap[key].Type === "Number") {
					const numberString = header[key].toString().replace(/ #/g, "");
					newFieldValue.Number = Number(numberString);
					newFieldValue.DataId = fieldNameToIdMap[key].DataId;
				}
				return newFieldValue;
			});

		header.Fields = unexpectedProperties;
	});

	//console.log("Migrated header model for report headers:", reportHeaders);
};

export const migrateHeaderModel = [key, applicable, modify];

